/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import React from 'react';
import ExpansionGrid from '../../Components/ExpansionGrid';

function FATCADetailsReview(props) {
    const { reviewData } = props

    const apiKeysUsedForDisplayingLabel = {
        "incomeSlabDesc": "Gross Annual Income",
        "politicallyExpPerson": "Client Politically Exposed",
        "tradingExperience": "Experience in Trading",
        "natureOfBusinessDesc": "Nature of business",
        "natureOfBusinessOther": "Nature of business Other",
        "occupationName": "Occupation",
        "sourceOfWealthDesc": "Source of wealth",
        "placeOfBirth": "Place of Birth",
        "countryOfBirth": "Country of Birth",
        "isFatca": "FATCA Consent"
    }

    const getAccordianData = () => {
        return <Grid container spacing={3} css={{padding:"10px"}}>
            { reviewData && reviewData?.kycStagingBasicdetails && Object.keys(apiKeysUsedForDisplayingLabel).map(apiKey=>
                <Grid container item xs={6} md={3} lg={2} alignItems={"center"} css={{border:"1px dashed lightgrey"}}>
                    <Grid item xs={12}>
                        <Typography variant="body2" css={{color:"#0098B0"}}>{apiKeysUsedForDisplayingLabel[apiKey]}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" /* color="#333333" fontWeight={"bold"} */ css={{wordBreak:"break-word"}}>
                            {reviewData && (apiKey == "tradingExperience" ? reviewData.kycStagingBasicdetails[apiKey].toString() 
                                : apiKey == "isFatca" ? (reviewData.kycStagingBasicdetails[apiKey] ? "YES" :  "NO") : reviewData.kycStagingBasicdetails[apiKey]?.toUpperCase()) || "--"}
                        </Typography>
                    </Grid>
                </Grid>
            )}
        </Grid>
    }

    return (
        <ExpansionGrid title={"FATCA Details"} accordianData={getAccordianData()} />
    );
}

export default FATCADetailsReview;